module.exports = __webpack_public_path__ + "static/img/1-left.c4dd750.png";


//////////////////
// WEBPACK FOOTER
// ./src/views/ability/img/1-left.png
// module id = xx0U
// module chunks = 1